import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Sign up", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", null, "Sign up", -1)
const _hoisted_6 = {
  key: 0,
  class: "error"
}

import { ref } from 'vue'
import { useRouter } from "vue-router";
import { useSignup } from '@/composables/useSignup';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref('')
const password = ref('')

const { signup, error } = useSignup()
const router = useRouter()

const handleSubmit = async () => {
  await signup(email.value, password.value)

  if (!error.value) {
    router.push('/')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _hoisted_2,
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      type: "email",
      name: "email",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, email.value]
    ]),
    _hoisted_4,
    _withDirectives(_createElementVNode("input", {
      type: "password",
      name: "password",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, password.value]
    ]),
    _hoisted_5,
    (_unref(error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})